import Vue from "vue";
import { BootstrapVueIcons, BootstrapVue } from "bootstrap-vue";
import "./bootstrap-vue-prod.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
